import { baseURL } from '../httpService/API';
import { hMacAjax } from 'grt-tool-lib-front';
import { genSensorsData } from '@/utils/buryPoint';
//首页搜索
export const handleHomeSearch = (params) => {
    genSensorsData({ content: params.title, module: 'home' }, 'searchTrack');
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/home/page/list', params);
};
export const handleHomeNav = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/decoration/homepage/navigation', params);
};

// 获取门户配置
export const getHomeConfig = (params) => {
    // 大赛作品集不调用此接口
    if (
        /workCollectionShow/.test(window.location.pathname) ||
        /\/tenant\//.test(window.location.pathname) ||
        /\/wcb_tenant/.test(window.location.pathname)
    ) {
        return {};
    }
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/decoration/homepage', params);
};

//获取租户门户列表
export const getTenantPortals = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/decoration/portal', params);
};

// 获取分类
export const getCategory = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/business/category', params);
};

//获取列表
export const getList = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/open/business/v1/app/page', data);
};

//根据视图id获取列表
export const getViewList = (data) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/view/data/content', data);
};

//获取资讯列表
export const getInfoList = (params) => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/business/notice/v1/info/list', params);
};

//获取最新资讯列表
export const getNewInfoList = () => {
    return hMacAjax.get(baseURL + '/grt-user-center-service/open/business/notice/v1/info/new');
};

//获取资讯详情
export const getInfoDetail = (id) => {
    return hMacAjax.get(baseURL + `/grt-user-center-service/open/business/notice/v1/info/${id}`);
};

// 获取商城列表
export const getEMallList = (data) => {
    return hMacAjax.post(baseURL + '/grt-trade-service/open/tdProduct/v1/page/search', data);
};

// 获取会议列表
export const getMeetingList = (data) => {
    return hMacAjax.post(baseURL + '/grt-user-center-service/open/meeting/v1/page', data);
};